<template>
  <div id="app">
    <notifications group="foo" position="top center" />
    <nav class="navbar navbar-expand-md fixed-top">
      <a class="navbar-brand" href="/" @click="clickmenu">
        <img src="/img/logo-header.png" alt="" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarsExampleDefault"
        aria-controls="navbarsExampleDefault"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 30 30"
          width="30"
          height="30"
          focusable="false"
        >
          <title>Menu</title>
          <path
            stroke="#34469b"
            stroke-width="2"
            stroke-linecap="round"
            stroke-miterlimit="10"
            d="M4 7h22M4 15h22M4 23h22"
          ></path>
        </svg>
      </button>

      <div class="collapse navbar-collapse" id="navbarsExampleDefault" ref="navbar">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" href="/formations" @click="clickmenu"
              >Formations <span class="sr-only">(current)</span></a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/fonctionnement" @click="clickmenu"
              >Fonctionnement</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/qui-sommes-nous" @click="clickmenu"
              >Qui sommes nous ?</a
            >
          </li>
          <li class="nav-item active">
            <a class="nav-link" href="/formateurs" @click="clickmenu">Formateurs</a>
          </li>
          <li class="nav-item-space"></li>
          <li class="nav-item">
            <a class="nav-link" href="/contact" @click="clickmenu">Contact</a>
          </li>
          <li class="nav-item" v-if="firebase.auth().currentUser">
            <a
              class="nav-link"
              v-if="firebase.auth().currentUser"
              @click="logout"
              href="/home"
              >Déconnexion</a
            >
          </li>
          <li class="nav-item">
            <a
              class="btn btn-primary"
              v-if="!firebase.auth().currentUser"
              href="/login"
              @click="clickmenu"
              >Connexion</a
            >
            <a
              class="btn btn-primary"
              v-if="firebase.auth().currentUser"
              href="/profil"
              @click="clickmenu"
              >Profil</a
            >
          </li>
        </ul>
      </div>
    </nav>
    <router-view />
    <footer class="footer-content">
      <div class="container justify-content-center">
        <!--<ul class="footer-img list-inline">-->
            <b-row >
              <b-col sm="8"
                ><b-img class="img-fluid" src="/img/footer-partenaires.png" alt="" gluid-grow
                ></b-img></b-col>
              <b-col sm="4"
                ><a href="/OFORIS - Certificat 01956 - QUALIOPI - 1.pdf" target="_blank">

                <b-img
                  class="img-fluid"
                  src="/img/certification_qualiopi.png"
                  alt=""
                  gluid-grow
                  ></b-img></a>
              </b-col>
            </b-row>
       <!-- </ul>-->

        <ul class="list-inline d-flex justify-content-center">
          <li class="list-item" style="margin-right: 10px; color: white">
            <span>&copy; OFORIS 2020 </span>
          </li>
          <li class="list-item" style="margin-right: 10px">
            <a href="/rgpd" style="color: white !important">Légal</a>
          </li>
          <li class="list-item" style="margin-right: 10px">
            <a href="/contact" style="color: white !important">Contact</a>
          </li>
        </ul>
        <ul class="list-inline d-flex justify-content-center">
          <li class="list-item" style="margin-right: 10px; color: gray">
            <span>
              Enregistré sous le numéro 75640485064. Cet enregistrement ne vaut pas
              agrément de l'Etat.</span
            >
          </li>
        </ul>
      </div>
    </footer>
    <cookie-law v-on:accept="enable_cookie()">
      <div slot-scope="props" class="text-center">
        <p>
          Nous utilisons des cookies pour vous garantir la meilleure expérience sur notre
          site web. Pour ces raisons, nous pouvons partager les données d'utilisation de
          notre site avec nos partenaires d'analyse. Vous pouvez choisir si vous souhaitez
          ou non consentir à notre utilisation des cookies via les options suivantes
        </p>
        <button class="btn btn-primary" @click="props.accept">
          <span>J'accepte</span>
        </button>
        &nbsp;
        <button class="btn btn-primary" @click="props.close">
          <span>Je refuse</span>
        </button>
      </div>
    </cookie-law>
  </div>
</template>
<script>
import firebase from "./main";
import CookieLaw from "vue-cookie-law";
import $ from "jquery";
export default {
  components: { CookieLaw },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      firebase: firebase,
      utilisateur: firebase.auth().currentUser,
      email: "",
      password: "",
      mainProps: { width: 45, height: 45, class: "m1" },
      admin: false,
      isCollapseOpen: false,
    };
  },
  created: function () {
    // `this` est une référence à l'instance de vm
    //var toto = this.$firestore.collection('parametres').get('expertises').orderBy('createdAt')
    if (firebase.auth().currentUser) {
      this.$firestore
        .collection("users")
        .doc(firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          var infos = snapshot.data();
          if (infos["admin"]) {
            this.admin = true;
          }
        });
    }
  },
  firestore: {},
  methods: {
    clickmenu: function () {
      //this.$refs['navbar'].collapse('hide');
      $(".navbar-collapse").collapse("hide");
    },
    enable_cookie: function () {
      this.$ga.enable();
    },
    rgpd: function () {
      this.$router.replace("rgpd");
    },
    contact: function () {
      this.$router.replace("contact");
    },
    logout: function () {
      $(".navbar-collapse").collapse("hide");
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    },
  },
};
</script>

<style lang="scss"></style>
